import { useQuery } from "@tanstack/react-query";
import axios from "axios";

const useAllOffers = () => {
    return useQuery({
        queryKey: ["everflow-offers"],
        queryFn: async () => {
            try {
                const baseUrl = process.env.REACT_APP_EFLOW_API_URL || "https://api.eflow.team/v1";
                const response = await axios.get(
                    `${baseUrl}/affiliates/alloffers`,
                    {
                        headers: {
                            "X-Eflow-API-Key": process.env.REACT_APP_EFLOW_API_KEY || "",
                        },
                    }
                );
                return response.data;
            } catch (error) {
                console.error("Error fetching offers:", error);
                throw error;
            }
        },
        retry: 3, // Retry the API request 3 times before giving up
        retryDelay: 1000, // Delay between retry attempts in milliseconds
        onError: (error) => {
            console.error("Error fetching offers:", error);
            // Implement fallback mechanism or return a default value
            // ...
        },
    });
};

export default useAllOffers;
